module.exports = __webpack_public_path__ + "img/bit-2.c6c2c5a2.png";